export const purple = {
    'code': '#7f2a61',
    'hex': '0x7f2a61',
}

export const skyblue = {
    'code': '#88d3e5',
    'hex': '0x88d3e5',
}

export const lightPurple = {
    'code': '#d5bee9',
    'hex': '0xd5bee9', // Softer, lighter complement to your deep purple
}

export const terracotta = {
    'code': '#c15c3d',
    'hex': '0xc15c3d',
}

export const deepTeal = {
    'code': '#236d82',
    'hex': '0x236d82', // Darker, high-contrast complement to your sky blue
}

export const aquaBlue = {
    'code': '#00a8d5',
    'hex': '0x00a8d5'
}

export const coral = {
    'code': '#e56b6f',
    'hex': '0xe56b6f',
}
export const softGold = {
    'code': '#f4d06f',
    'hex': '0xf4d06f',
}

export const lightgreen = {
    'code': '#9ED19F',
    'hex': '0x9ED19F',
}

export const darkblue = {
    'code': '#0a0936',
    'hex': '0x0a0936',
}

export const yellow_fs = {
    'code': '#FFC107',
    'hex': '0xFFC107',
}

export const blue_fs = {
    'code': '#1E88E5',
    'hex': '0x1E88E5',
}

export const white = {
    'code': '#ffffff',
    'hex': '0xffffff',
}

export const black = {
    'code': '#000000',
    'hex': '0x000000',
}

export const dark = {
    'code': '#2e2e2e',
    'hex': '0x2e2e2e'
}